import Vue from 'vue';
import { BlockDTO } from '../../../model/BlockDTO';

export async function apartmentLocationProjectGalleryData(context: Vue, block: BlockDTO) {
	let gallery = await context.$resourceService.fetchImages(block.id, "project-gallery", context.$store.boIdMapping);

	return {
		gallery
	};
}
